import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"

export default function FAQSection() {
  return (
    <section id="faq" className="py-24 sm:py-36 bg-white">
      <div className="max-w-3xl mx-auto px-6 sm:px-10">

        {/* Header */}
        <div className="mb-20">
          <div className="w-10 h-[3px] bg-secondary mb-8 rounded-full" />
          <h2 className="text-4xl sm:text-6xl font-black text-[#0D0D0D] tracking-tight leading-[1.05] text-balance mb-5">
            {"Frequently asked questions"}
          </h2>
          <p className="text-lg text-[#0D0D0D]/55 leading-relaxed">
            {"Everything you need to know about Kanu Energy."}
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="item-1" className="border-[#0D0D0D]/10">
            <AccordionTrigger className="text-base sm:text-lg font-semibold text-[#0D0D0D] hover:no-underline hover:text-[#1D591B] py-7 [&[data-state=open]]:text-[#1D591B] [&[data-state=open]>svg]:text-[#1D591B] [&>svg]:text-[#0D0D0D]/30 [&>svg]:size-5 transition-colors duration-200">
              What is the UK connection queue and why does it matter when investing?
            </AccordionTrigger>
            <AccordionContent className="text-[#0D0D0D]/60 leading-relaxed text-base pb-7">
              The UK connection queue is a 125 GW backlog of renewable energy projects waiting for grid connection offers from the National Energy System Operator (NESO)
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2" className="border-[#0D0D0D]/10">
            <AccordionTrigger className="text-base sm:text-lg font-semibold text-[#0D0D0D] hover:no-underline hover:text-[#1D591B] py-7 [&[data-state=open]]:text-[#1D591B] [&[data-state=open]>svg]:text-[#1D591B] [&>svg]:text-[#0D0D0D]/30 [&>svg]:size-5 transition-colors duration-200">
              What data sources does Kanu aggregate?
            </AccordionTrigger>
            <AccordionContent className="text-[#0D0D0D]/60 leading-relaxed text-base pb-7">
              Kanu pulls data from all 14 DNO regions, the Renewable Energy Planning Database (REPD), National Energy System Operator (NESO), local planning portals and UK Government Websites. Every data point is clearly source-labelled so you always know where an insight came from.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-3" className="border-[#0D0D0D]/10">
            <AccordionTrigger className="text-base sm:text-lg font-semibold text-[#0D0D0D] hover:no-underline hover:text-[#1D591B] py-7 [&[data-state=open]]:text-[#1D591B] [&[data-state=open]>svg]:text-[#1D591B] [&>svg]:text-[#0D0D0D]/30 [&>svg]:size-5 transition-colors duration-200">
              How does the Gate 2 Prediction Engine work?
            </AccordionTrigger>
            <AccordionContent className="text-[#0D0D0D]/60 leading-relaxed text-base pb-7">
              Our Gate 2 Prediction scores are calculated using planning outcomes and compares the project against clean power 2030 targets. Projects are classified as High, Medium, or Low likelihood with an accompanying confidence percentage, helping you prioritise the most investable opportunities.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-4" className="border-[#0D0D0D]/10">
            <AccordionTrigger className="text-base sm:text-lg font-semibold text-[#0D0D0D] hover:no-underline hover:text-[#1D591B] py-7 [&[data-state=open]]:text-[#1D591B] [&[data-state=open]>svg]:text-[#1D591B] [&>svg]:text-[#0D0D0D]/30 [&>svg]:size-5 transition-colors duration-200">
              Can I query the data in plain English?
            </AccordionTrigger>
            <AccordionContent className="text-[#0D0D0D]/60 leading-relaxed text-base pb-7">
              Yes. Kanu's AI Query Layer lets you ask natural-language questions like "Which solar projects are awaiting connection in the UKPN region?" and returns instant, cited answers. Every response links back to its source so results are fully verifiable.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-5" className="border-[#0D0D0D]/10 last:border-b">
            <AccordionTrigger className="text-base sm:text-lg font-semibold text-[#0D0D0D] hover:no-underline hover:text-[#1D591B] py-7 [&[data-state=open]]:text-[#1D591B] [&[data-state=open]>svg]:text-[#1D591B] [&>svg]:text-[#0D0D0D]/30 [&>svg]:size-5 transition-colors duration-200">
              How does Kanu align with the Clean Power 2030 strategy?
            </AccordionTrigger>
            <AccordionContent className="text-[#0D0D0D]/60 leading-relaxed text-base pb-7">
              Kanu is built to dynamically respond to policy signals from NESO, DESNEZ and Ofgem such as Clean Power 2030 and the Strategic Spatial Energy Plans (SSEP). This alignment means that Kanu highlights projects in the most favourable policy and market conditions, so your pipeline is always calibrated to where government support is strongest.
            </AccordionContent>
          </AccordionItem>
        </Accordion>

      </div>
    </section>
  )
}
